export default {
      id: "menu__video-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#menu__video",
      toString: function () {
        return this.url;
      }
    }